import Validation from '@core/logic/Validation'
import ExistingPortfolioDeclaration from '@master/model/kyc-form/existing-plans/ExistingPortfolioDeclaration'
import { IExistingPortfolio } from '@master/model/kyc-form/existing-plans/IExistingPortfolio'

export default class ExistingPortfolioDeclarationValidation extends Validation {
  validate (declaration: ExistingPortfolioDeclaration, portfolios: IExistingPortfolio[], belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, WHEN } = this.validator()
    ADD(REQUIRE(declaration.review, 'Existing Portfolio Review Option must be filled'), ['Insurance Portfolio'], ['review'])
    ADD(WHEN(declaration.review === 'no', REQUIRE(declaration.reviewReasons, 'Review reasons must be filled when client do not want to existing portfolios to take into consideration.')), ['Insurance Portfolio'], ['reviewReasons'])

    ADD(() => {
      if (declaration.review === 'yes') {
        if (!portfolios.some(pf => pf.isValid())) {
          return 'At least one policy must be stated when Yes is selected.'
        }
      }
      return null
    }, ['Insurance Portfolio'])

    return getMessages()
  }
}
